import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';

const DynamicStepIcon = (props) => {
  const theme = useTheme();
  const { active, completed, icon, iconSize } = props;
  const getColor = () => {
    if (active) return theme.palette.common.white;
    if (completed) return theme.palette.primary.main;
    return theme.palette.neutral.A600;
  };

  return (
    <Typography
      variant="small_3"
      fontWeight={600}
      fontSize={iconSize * 0.5}
      color={getColor()}
      sx={{
        borderRadius: '50%',
        borderColor: theme.palette.neutral.A400,
      }}
    >
      0{icon}
    </Typography>
  );
};

DynamicStepIcon.propTypes = {
  active: PropTypes.bool.isRequired,
  completed: PropTypes.bool.isRequired,
  icon: PropTypes.number.isRequired,
  iconSize: PropTypes.string,
};
DynamicStepIcon.defaultProps = {
  iconSize: '45px',
};

export default DynamicStepIcon;
